import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, } from "react-router-dom";
import { Col, Row, Card, Container } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'

import Store from "../store/Store";
import useSubTask from '../hooks/useSubTask';
import Api from "../api/Api";
import NoteBlock from '../components/NoteBlock';

import '../css/task.css'
import Subtask from '../components/Subtask';

/**
 * @typedef SubTask
 * @property {number} id
 * @property {string} task_name
 * @property {string} item_name
 * @property {string} [cost]
 * @property {string} [total_cost]
 * @property {string} [amount]
 * @property {string} [total_amount]
 * 
 * 
 * @typedef Task
 * @property {number} id
 * @property {string} guid
 * @property {string} name
 * @property {number} status
 * @property {number} farm_id
 * @property {string} table_id
 * @property {number} harvest_year_id
 * @property {string} harvest_year_name
 * @property {string} task_area
 * @property {string} task_cost
 * @property {string} started_at
 * @property {string} completed_at
 * @property {boolean} has_nebih_task
 * @property {boolean} is_nebih_sendable
 * @property {any} [eGN_status]
 * @property {array<SubTask>} sub_tasks
 * @property {array} parcels
 * @property {array<string>} notes
 * @property {number} dirty
 */
export default function EditTask() {
    const params = useParams();
    const navigate = useNavigate();

    const { tasks, user, tables, farms } = Store.getState();
    /** @type {Task} task */
    const task = tasks.find(element => element.guid === params.taskGuid);
    const taskForSubTasks = task || { sub_tasks: [] };

    const {  toggleAllSubTasks, allSubTasksOpen } = useSubTask(params.taskGuid, taskForSubTasks);
    const [modifiedTask, setModifiedTask] = useState(task);

    useEffect(() => {
        setModifiedTask(task);
    }, [task]);

    const [tooltip, setTooltip] = useState({ show: false, text: '', x: 0, y: 0 });
    const isOwn = (taskToCheck) => taskToCheck.sub_tasks?.some(subtask => subtask.user_id && subtask.user_id === user?.id) || false;

    if (!task) {
        return (<p>Az oldal nem található</p>);
    }

    const isTaskOwn = isOwn(task);
    const taskStatuses = farms?.find(farm => farm.id === task.farm_id)?.statuses || [];
    const currentStatus = taskStatuses.find(status => status.id === task.status);
    const statusLabel = currentStatus?.label || (task.status === 1 ? 'Piszkozat' : task.status === 2 ? 'Véglegesített' : 'Ismeretlen');
    const statusColor = currentStatus?.color || (task.status === 1 ? 'gray' : task.status === 2 ? 'green' : 'black');

    const setValue = (field, value) => {
        setModifiedTask(currentTask => ({ ...currentTask, [field]: value, dirty: 1 }));
    }

    const saveChanges = () => {
        if (window.confirm('Biztosan be akarja fejezni a feladatot?')) {
            let param = {
                id: modifiedTask.guid,
                task: modifiedTask
            }
            Api.updateTask(param);
        }

    }
    const goBack = () => {
        navigate(-1);
    }

    /** tooltip */
    const showTooltip = (event, text) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setTooltip({ show: true, text, x: rect.left + window.scrollX, y: rect.top + window.scrollY - 30 });
    };
    const hideTooltip = () => {
        setTooltip({ show: false, text: '', x: 0, y: 0 });
    };

    const statusIcons = (task) => {
        // Először ellenőrizzük, hogy a task.eGN_status nem null és az icons létezik
        if (task.eGN_status && task.eGN_status.icons) {
            return task.eGN_status.icons.map((icon, index) => (
                <FontAwesomeIcon
                    key={index}
                    className="icon"
                    style={{ float: 'right' }}
                    icon={icon.icon_class}
                    onTouchStart={(e) => showTooltip(e, icon.tooltip)}
                    onMouseEnter={(e) => showTooltip(e, icon.tooltip)}
                    onMouseLeave={hideTooltip}
                />
            ));
        }
        return null;  // nincs elérhető ikon
    };


    const relatedTables = tables.filter(t => task.table_id?.includes(t.table_id));
    const tableNames = relatedTables.map(t => t.name).join(', ') ?? null;
    const warehouseName = task.sub_tasks.map(subTask => subTask.warehouse_name??null);



    const isNebihSendable = (task) => {
        // task.is_nebih_sendable ? 
        // <FontAwesomeIcon onClick={sendTaskToNebih} className="icon" style={{float: 'right', margin: '0 0.5rem', cursor: 'pointer'}} icon={faCloudUpload}/> 
        // : <></>

        if (task.is_nebih_sendable) {
            return <FontAwesomeIcon
                key={'is_nebih_sendable'}
                className="icon"
                style={{ float: 'right', cursor: 'pointer', margin: '0 0.5rem' }}
                icon={'fa fa-solid fa-cloud-arrow-up'}
                onClick={sendTaskToNebih}
            />
        }
        return null;
    }

    const isCompleted = (task) => {
        // task.completed_at ? <FontAwesomeIcon className="icon" style={{float: 'right'}} icon={faCircleCheck}/> : <></>

        if (task.completed_at) {
            return <FontAwesomeIcon
                key={'completed_at'}
                className="icon"
                style={{ float: 'right' }}
                // icon={'fa-solid fa-circle-check'}
                icon={faCircleCheck}
                onTouchStart={(e) => showTooltip(e, 'Véglegesített')}
                onMouseEnter={(e) => showTooltip(e, 'Véglegesített')}
                onMouseLeave={hideTooltip}
            />
        }
        return null;
        // return <FontAwesomeIcon
        //     key={'completed_at'}  
        //     title={'Piszkozat'} 
        //     className="icon"
        //     style={{ float: 'right' }}
        //     icon={'fa-regular fa-pen-to-square'}
        // />
    }

    const sendTaskToNebih = async () => {

        if (window.confirm('Biztosan beküldi az adatokat?')) {
            let param = {
                task_id: task.guid,
            }

            try {
                const response = await Api.sendTaskToNebih(param);
                if (response === false || response?.error) {
                    alert("Hiba történt a beküldés során!");
                    return; // Megakadályozza az átirányítást
                }

                window.location.assign("/edit-task/" + task.guid);
            } catch (error) {
                alert("Hálózati vagy szerverhiba történt!");
                console.error(error);
            }

        }
    }

    

    return (
        <div>
            <div className={"page-head my-2 d-flex"}>
                {/* <h3 className="title"><strong>{task.name}</strong></h3> */}
                <h3 className="title"><strong>Feladat</strong></h3>
                <div>
                    <button onClick={() => { goBack() }} className={"btn button"}>{"< Vissza"} </button>
                </div>
            </div>
            <hr />
            <Card border="light" className="task" key={'task_' + task.id}>
                <Card.Header>
                    {/* Bal oldalon ikon és név */}
                    <div className="d-flex align-items-start">
                        {/* Bal oldalon FontAwesome ikon */}
                        <div className="task-icon">
                            <FontAwesomeIcon className="icon" icon={'seedling'} />
                        </div>

                        {/* Jobb oldalon a név és a dátumok */}
                        <div className="task-info">
                            <strong>{task.name}</strong>
                        </div>
                    </div>
                    {/* Jobb oldalon gomb */}
                    <div className="d-flex align-items-center">
                        {/* {isNebihSendable(task)}
                            {statusIcons(task)}
                            {isCompleted(task)} */}
                        {/* <span className="btn button btn-flt-r" onClick={(e) => redirectToTable(e, "/edit-task/" + task.guid)}>
                                <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                            </span> */}
                    </div>
                </Card.Header>
                <Card.Body>
                    <div>
                        {tableNames && <Row>
                            <Col><span>Tábla</span></Col>
                            <Col><span><strong>{tableNames}</strong></span></Col>
                        </Row>}
                        {warehouseName && <Row>
                            <Col><span>Raktár</span></Col>
                            <Col><span><strong>{warehouseName.join(', ')}</strong></span></Col>
                        </Row>}
                        <Row>
                            <Col><span>Aratási év</span></Col>
                            <Col><span></span>{task.harvest_year_name}</Col>
                        </Row>
                        <Row>
                            <Col><span>Terület</span></Col>
                            <Col><span>{task.task_area}</span></Col>
                        </Row>

                        {user?.permissions?.includes('pwaViewCosts') && (
                            <Row>
                                <Col><span>Költség/ha</span></Col>
                                <Col><span>{task.task_cost}</span></Col>
                            </Row>
                        )}

                        <Row>
                            <Col><span>Kezdés</span></Col>
                            <Col><span>{task.started_at}</span></Col>
                        </Row>
                        {/* {task.completed_at && 
                            <>
                                <Row>
                                    <Col><span>Befejezés</span></Col>
                                    <Col><span>{task.completed_at}</span></Col>
                                </Row>
                            </>
                        } */}

                        {/* Befejezés dátum */}
                        <Row>
                            <Col><span>Befejezés</span></Col>
                            <Col>
                                {task.completed_at || !isTaskOwn ? (
                                    <span>{task.completed_at || '-'}</span>
                                ) : (
                                    <input
                                        className='input taskview-date'
                                        type="date"
                                        value={modifiedTask.completed_at || ''}
                                        onChange={(e) => setValue('completed_at', e.target.value)}
                                    />
                                )}
                            </Col>
                        </Row>

                        {/* Státusz */}
                        <Row className="mt-2">
                            <Col><span>Státusz</span></Col>
                            <Col>
                                {!isTaskOwn ? (
                                    // Olvasható badge
                                    <strong style={{ color: statusColor }}>{statusLabel}</strong>
                                ) : (
                                    // Állítható select
                                    <select
                                        className='input taskview-date'
                                        value={modifiedTask.status}
                                        onChange={(e) => setValue('status', parseInt(e.target.value))}
                                    >
                                        <option value={1} style={{ color: 'gray' }}>Piszkozat</option>
                                        <option value={2} style={{ color: 'green' }}>Véglegesített</option>
                                        {taskStatuses.map(s => (
                                            <option
                                                key={s.id}
                                                value={s.id}
                                                style={{ color: s.color || 'black' }}
                                            >
                                                {s.label}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </Col>
                        </Row>


                        {/* Mentés gomb csak ha saját és nincs completed_at */}
                        {!task.completed_at && isTaskOwn && (
                            <Container className="openclose-btn-container">
                                <button className={"btn button m-2"} onClick={saveChanges}>Mentés</button>
                            </Container>
                        )}


                        {/* {task.is_nebih_sendable && 
                            <button className={"btn button m-2"} onClick={()=>{sendTaskToNebih()}}>Véglegesítés és beküldés</button>
                        } */}

                    </div>
                </Card.Body>
            </Card>


            {
                <NoteBlock
                    name="task" // fontos! ez meghatározza az API url végpontot is!
                    notes={task.notes}
                    cardClass="task mb-2 mt-3"
                    parentItem={task}
                    user={user}
                />
            }

            {user?.permissions?.includes('pwaViewSubtasks') && (
                <>
                    <div className={"page-head mb-3 mt-4 d-flex "}>
                        <h4 className="title"><strong>{"Részfeladat"}</strong></h4>
                        <button className="btn button" onClick={toggleAllSubTasks}>
                            {allSubTasksOpen
                                ? (<>Összes bezárása <FontAwesomeIcon icon="fa-solid fa-chevron-up" /></>)
                                : (<>Összes lenyitása <FontAwesomeIcon icon="fa-solid fa-chevron-down" /></>)
                            }
                        </button>
                    </div>

                    <div>
                        {task.sub_tasks && task.sub_tasks.map(subTask => <Subtask key={subTask.id} task={task} subTask={subTask} />)}
                    </div>
                </>
            )}

            {tooltip.show && (
                <div //className='alert alert-info'
                    style={{
                        position: "absolute",
                        top: `${tooltip.y}px`,
                        left: `${tooltip.x}px`,
                        backgroundColor: "#333",
                        color: "#fff",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        fontSize: "12px",
                        zIndex: 1000,
                        whiteSpace: "nowrap"
                    }}
                >
                    {tooltip.text}
                </div>
            )}

        </div>
    )
}
